import React, { FC, useEffect, useState } from "react";
import { Button, Modal, Row, Col } from "antd";
import _ from "lodash";
import { ReactSVG } from "react-svg";
import { wrapRequestPayload } from "../../../helpers/request/RequestPayload";
import {
  getPageRequestPublishTopic,
  getPageSubscriptionTopic,
  getSearchMessageSubscriptionTopic,
  getSearchMessagePublishTopic,
} from "hooks/MQTTConstants";
import { useLocation } from "react-router-dom";
import { SocketTopics } from "constants/enums";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { useDispatch } from "react-redux";
import { CLEAR_SUMMARY } from "reducers/reducer";
import LocationItem from "../../../common/LocationItem";
import { attributeKeyGenerator } from "utils/appUtil";
import { generateUUID, formatForRedis } from "utils/appUtil";
import { GET_AGGREGATE } from "../../../reducers/reducer";
import useSocketActions from "../../../hooks/socketActions";

import Geocode from "react-geocode";
Geocode.setApiKey("AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY");
Geocode.setLanguage("en");
Geocode.setRegion("us");

const polyline = require("google-polyline");

const unitMap = {
  imperial: "miles",
  metric: "km",
};

/*global google*/

const RideSummaryModal: FC<{ socket: ISocket; params?: any }> = ({
  socket,
  params,
}) => {
  const { search } = useLocation();
  const { page, messages, gps } = useSelector((state: RootState) => state.auth);
  const [pageInfo, setPageInfo] = useState<any[]>([]);
  const [meterInfo, setMeterInfo] = useState<any[]>([]);
  const [tripInfo, setTripInfo] = useState<any[]>([]);
  const [fleetInfo, setFleetInfo] = useState<any>({ arr: [] });
  const dispatch = useDispatch();
  const [imagePath, setImagePath] = useState<string>();
  const [pickupAddress, setPickupAddress] = useState<string>("");
  const [dropOffAddress, setDropOffAddress] = useState<string>("");
  const { handleMessages } = useSocketActions();

  const reverseGeocode = (marker: any, callback) => {
    Geocode.fromLatLng(marker.lat, marker.long).then(
      (response) => {
        callback(response.results[0].formatted_address);
      },
      (error) => {
        console.error(error);
      }
    );
  };

  const getMessages = (pageId) => {
    const query = new URLSearchParams(search);
    const connectionId = query.get("connectionId");
    const requestId = generateUUID();
    localStorage.setItem("requestId", requestId);
    localStorage.setItem("requestService", "summary");
    // const messageRequest: any = {
    //   searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:messageCreatedAtIndex`,
    //   searchQuery: `@pageId:{${pageId}}@type:{${formatForRedis("gps-report")}}`,
    //   searchOptions: "SORTBY createdAt DESC ",
    //   paths: ["$"],
    //   returnPaths: ["$"],
    // };
    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   // getSearchMessagePublishTopic(pageId, connectionId),
    //   `${process.env.REACT_APP_ECO_SYSTEM}/service/live/service/liveStorage/searchMessage`,
    //   wrapRequestPayload(messageRequest, requestId)
    // );

    const messageRequest: any = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:message:createdAt`,
          searchQuery: `@pageId:{${pageId.toString()}}@type:{'gps\\-report'}`,
          searchOptions: "TIMEOUT 100",
        },
        load: { object: "$" },
      },
      operations: [
        {
          sortBy: {
            properties: [
              {
                field: "@createdAt",
                order: "DESC",
              },
            ],
          },
        },
      ],
      result: {
        pagination: {
          offset: 0,
          limit: 1,
        },
      },
      sortBy: {
        properties: [
          {
            field: "@createdAt",
            order: "DESC",
          },
        ],
        max: 10000,
      },
    };

    dispatch(
      GET_AGGREGATE({
        requestData: messageRequest,
        callback: (response) => {
          console.log("message response", response);
          handleMessages(requestId, response);
        },
      })
    );
  };

  useEffect(() => {
    dispatch({ type: CLEAR_SUMMARY });
    if (socket.client) {
      const query = new URLSearchParams(search);
      const connectionId = query.get("connectionId") || "0";
      const pageId = query.get("pageId");
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getPageSubscriptionTopic(connectionId)
      );
      if (pageId) {
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getPageRequestPublishTopic(connectionId),
          wrapRequestPayload(
            {
              objectId: pageId,
              paths: ["$"],
              returnPaths: ["$"],
            },
            pageId
          )
        );
        socket.subscribeToEvent(
          SocketTopics.SubscribePageTopics,
          // getSearchMessageSubscriptionTopic(pageId, connectionId)
          `${process.env.REACT_APP_ECO_SYSTEM}/service/live/service/liveStorage/searchMessage/reply`
        );
        // getMessages(pageId);
      }
    }
  }, [search, socket.client]);

  useEffect(() => {
    if (messages && messages.length > 0) {
      let requestData = {
        filter: `ecosystem=${process.env.REACT_APP_ECO_SYSTEM} iotUdid=${messages?.[0].data?.iotUdid} userId=${messages?.[0].senderId} iotUserId=${messages?.[0].data.iotUserId} page=true`,
        fromTimestamp: new Date(messages?.[0].data?.startIotAt).getTime(),
        toTimestamp: new Date(messages?.[0].data?.endIotAt).getTime(),
        options: {
          withLabels: true,
        },
      };
      dispatch({
        type: "GET_HISTORICAL_GPS",
        payload: { requestData },
      });
    }
  }, [messages]);

  useEffect(() => {
    if (gps) {
      const points = [];
      gps?.points?.map((point) => {
        points.push([
          point?.dataset?.locationGps?.lat,
          point?.dataset?.locationGps?.long,
        ]);
      });
      const encodedPolyline = polyline.encode(points);

      const origin =
        page?.persistent?.static?.profile?.pickupLocation?.coordinates ||
        page?.persistent?.static?.dashboard?.pickupLocation?.coordinates ||
        page?.persistent?.static?.live?.location?.coordinates;

      console.log("origin", origin);

      const destination =
        page?.persistent?.static?.profile?.tripDetails?.end?.location ||
        page?.persistent?.static?.meter?.tripDetails?.end?.location
          ?.coordinates;
      const start = origin.lat + "," + origin.long;
      const end = destination.lat + "," + destination.long;
      let markers: any = [];
      markers.push("markers=color:green|" + start);
      markers.push("markers=color:blue|" + end);
      markers = markers.join("&");
      setImagePath(
        "https://maps.googleapis.com/maps/api/staticmap?size=1000x1000&maptype=roadmap&path=enc:" +
          encodedPolyline +
          "&" +
          markers +
          "&key=" +
          "AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"
      );
    }
  }, [gps]);

  const getUnit = (name, currenyUnit, distanceUnit) => {
    switch (name) {
      case "movingDistance":
        return distanceUnit;
      case "unit":
        return "";
      case "waitTime":
        return "hh:mm:ss";
      default:
        return currenyUnit;
    }
  };

  useEffect(() => {
    if (page) {
      console.log("page", page);

      const query = new URLSearchParams(search);
      const pageId = query.get("pageId");
      if (pageId !== page.objectId) return;

      getMessages(pageId);

      let info = [];
      const onMove = {
        ...(page?.persistent?.static?.profile || {}),
        ...(page?.persistent?.static?.ride || {}),
        ...(page?.persistent?.dynamic?.ride || {}),
        ...(page?.persistent?.static?.dashboard || {}),
        ...(page?.persistent?.static?.meter || {}),
      };
      let type = onMove.type;
      delete onMove.summary;
      delete onMove.type;
      if (type === "cad") {
        info = [{ name: "Event Type", value: "CAD" }];
      } else {
        info = [
          { name: "Event Type", value: "Hail ride" },
          { name: "First Name", value: "N/A" },
          { name: "Last Name", value: "N/A" },
          { name: "Phone", value: "N/A" },
          { name: "Alternative Phone", value: "N/A" },
        ];
      }
      Object.keys(onMove).map((key) => {
        if (typeof onMove[key] === "string") {
          info.push({ name: attributeKeyGenerator(key), value: onMove[key] });
        }
      });

      info = [
        ...info,
        {
          name: "Start Time",
          value: getLocalDatetimeString(
            page?.persistent?.static?.metadata?.createdAt
          ),
        },
        {
          name: "Stop Time",
          value: getLocalDatetimeString(
            page?.persistent?.static?.profile?.tripDetails?.end?.time ||
              page?.persistent?.static?.meter?.tripDetails?.end?.time
          ),
        },
      ];
      setPageInfo(info);
      const tripDetailsInfo = [];
      const meterDetailsInfo = [];
      const fleetDetailsInfo = { logo: undefined, arr: [], comment: "" };
      const trip =
        page?.persistent?.static?.profile?.tripDetails ||
        page?.persistent?.static?.meter?.tripDetails ||
        {};
      const meter =
        page?.persistent?.static?.profile?.meterDetails ||
        page?.persistent?.static?.meter?.meterDetails ||
        {};
      const currency = meter.currency;
      delete meter.waitIndex;
      delete meter.movingIndex;
      delete meter.currency;
      if (meter.waitTime) {
        const waitTime = new Date(meter.waitTime * 1000)
          .toISOString()
          .slice(11, 19);
        meter.waitTime = `${waitTime}`;
      }
      if (meter.tip) {
        meter.tip = Math.round(meter.tip);
      }
      meter.movingDistance = `${meter.movingDistance.toFixed(1)}`;
      meter.amount = `${meter.amount}`;
      const fleet =
        page?.persistent?.static?.profile?.fleetDetails ||
        page?.persistent?.static?.meter?.fleetDetails ||
        {};
      // const vehicle = page?.persistent?.static?.profile?.vehicleDetails ?? {};
      fleetDetailsInfo.logo = fleet?.logoImage?.urls?.original?.url;
      fleetDetailsInfo.comment = fleet?.comment || "";
      console.log("fleet details", fleet);
      fleetDetailsInfo.arr.push({
        name: "Company name",
        value: fleet?.companyName ?? "N/A",
      });
      fleetDetailsInfo.arr.push({
        name: "Company address",
        value: fleet?.location?.attributes?.address ?? "N/A",
      });
      // fleetDetailsInfo.arr.push({
      //   name: "Driver vehicle",
      //   value: vehicle?.name ?? "N/A",
      // });
      Object.keys(trip).map((key) => {
        if (typeof trip[key] === "string" || typeof trip[key] === "number") {
          tripDetailsInfo.push({
            name: attributeKeyGenerator(key),
            value: trip[key],
          });
        }
      });
      Object.keys(meter).map((key) => {
        if (typeof meter[key] === "string" || typeof meter[key] === "number") {
          meterDetailsInfo.push({
            name: attributeKeyGenerator(key),
            value: meter[key],
            unit: getUnit(key, currency, unitMap[meter.unit]),
          });
        }
      });
      setTripInfo(tripDetailsInfo);
      setMeterInfo(meterDetailsInfo);
      setFleetInfo(fleetDetailsInfo);
      // handleDirection(
      //   page?.persistent?.static?.profile?.pickupLocation?.coordinates ||
      //     page?.persistent?.static?.live?.location?.coordinates,
      //   page?.persistent?.static?.profile?.tripDetails?.end?.location
      // );
      reverseGeocode(
        page?.persistent?.static?.profile?.pickupLocation?.coordinates ||
          page?.persistent?.static?.dashboard?.pickupLocation?.coordinates ||
          page?.persistent?.static?.live?.location?.coordinates,
        (address) => {
          setPickupAddress(address);
        }
      );
      reverseGeocode(
        page?.persistent?.static?.profile?.tripDetails?.end?.location ||
          page?.persistent?.static?.meter?.tripDetails?.end?.location
            ?.coordinates,
        (address) => {
          setDropOffAddress(address);
        }
      );
    }
  }, [page]);

  const handleDirection = (origin, destination) => {
    const DirectionsService = new google.maps.DirectionsService();
    DirectionsService.route(
      {
        origin: new google.maps.LatLng(origin.lat, origin.long),
        destination: new google.maps.LatLng(destination.lat, destination.long),
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          const path = result.routes?.[0]?.overview_polyline;
          const start = origin.lat + "," + origin.long;
          const end = destination.lat + "," + destination.long;
          let markers: any = [];
          markers.push("markers=color:green|" + start);
          markers.push("markers=color:blue|" + end);
          markers = markers.join("&");

          // &path=color:0x0000ff|weight:5|40.7687605058,-73.9982199669|44.655916705,-63.577837944|50.9046160427,-1.42889857292
          setImagePath(
            "https://maps.googleapis.com/maps/api/staticmap?size=1000x1000&maptype=roadmap&path=enc:" +
              path +
              "&" +
              markers +
              "&key=" +
              "AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"
          );
          console.log(
            "https://maps.googleapis.com/maps/api/staticmap?size=1000x1000&maptype=roadmap&path=enc:" +
              path +
              "&" +
              markers +
              "&key=" +
              "AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"
          );
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );
  };

  const getLocalDatetimeString = (date) => {
    // [], {hour: '2-digit', minute:'2-digit', hour12: true}
    const dateObject = new Date(date);
    return dateObject
      ? `${dateObject.toLocaleDateString()} ${dateObject.toLocaleTimeString()}`
      : "N/A";
  };

  return (
    <Modal
      title=""
      visible={true}
      width="100%"
      className="beam-modal analytics-summary-modal"
      footer={[]}
      destroyOnClose={true}
    >
      {page && (
        <React.Fragment>
          <Row>
            <Col
              sm={12}
              xs={24}
              className={`${window.innerWidth > 700 ? "pr-3" : ""}`}
            >
              <Row className="d-flex">
                <Col>
                  <h3 className="mb-1">
                    {page?.persistent?.static?.metadata?.title}
                  </h3>
                  <h4>Ride information</h4>
                </Col>
                <Col>
                  <Button className="beam-btn icon-btn ml-2">
                    <ReactSVG
                      src="/images/flag-icon.svg"
                      className={`${
                        page?.nonpersistent?.static?.live?.status?.name ??
                        "gray"
                      }-icon`}
                    />
                  </Button>
                  <Button className="beam-btn icon-btn ml-2">
                    <ReactSVG src="/images/iot-icon.svg" />
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <ul className="incident-information mt-2">
                    {pageInfo.map((item, i) => (
                      <li key={i}>
                        <Row>
                          <Col span={12}>
                            <p>{item.name}</p>
                          </Col>
                          <Col span={12}>
                            <p>{item.value}</p>
                          </Col>
                        </Row>
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>

              <Row className="d-flex mt-3">
                <Col>
                  <h4>Travel information</h4>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <ul className="incident-information mt-2">
                    {tripInfo.map((item, i) => (
                      <li key={i}>
                        <Row>
                          <Col span={12}>
                            <p>{item.name}</p>
                          </Col>
                          <Col span={12}>
                            <p>{item.value}</p>
                          </Col>
                        </Row>
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>

              <Row className="d-flex mt-3">
                <Col>
                  <h4>Fare breakdown</h4>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <ul className="incident-information mt-2">
                    {meterInfo.map((item, i) => (
                      <li key={i}>
                        <Row>
                          <Col span={8}>
                            <p>{item.name}</p>
                          </Col>
                          <Col span={8}>
                            <p>{item.unit}</p>
                          </Col>
                          <Col span={8}>
                            <p>{item.value}</p>
                          </Col>
                        </Row>
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>
            </Col>
            <Col
              sm={12}
              xs={24}
              className={`mt-3 ${window.innerWidth > 700 ? "pl-3" : ""}`}
            >
              <h4 className="mt-3">Locations</h4>

              {imagePath && (
                <Row>
                  <Col span={24} className="mt-2 incident-information">
                    <img src={imagePath} width="100%" alt="" />
                  </Col>
                </Row>
              )}
              <Row className="locations mt-2">
                <Col span={24}>
                  <React.Fragment>
                    <LocationItem
                      type="green"
                      title="Pickup location"
                      locationObj={
                        page?.persistent?.static?.profile?.pickupLocation ||
                        page?.persistent?.static?.dashboard?.pickupLocation ||
                        page?.persistent?.static?.live?.location
                      }
                      address={pickupAddress}
                    />
                    <LocationItem
                      type="blue"
                      title="Dropoff location"
                      locationObj={{
                        coordinates:
                          page?.persistent?.static?.profile?.tripDetails?.end
                            ?.location ||
                          page?.persistent?.static?.meter?.tripDetails?.end
                            ?.location?.coordinates,
                      }}
                      address={dropOffAddress}
                    />
                  </React.Fragment>
                </Col>
              </Row>

              <Row className="d-flex mt-3">
                <Col>
                  <h4>Fleet information</h4>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <ul className="incident-information mt-2">
                    {fleetInfo?.logo && (
                      <li key={-1}>
                        <Row>
                          <Col span={12}>
                            <p>Company logo</p>
                          </Col>
                          <Col span={12}>
                            <img src={fleetInfo?.logo} width={100} alt="" />
                          </Col>
                        </Row>
                      </li>
                    )}

                    {fleetInfo?.arr?.map((item, i) => (
                      <li key={i}>
                        <Row>
                          <Col span={12}>
                            <p>{item.name}</p>
                          </Col>
                          <Col span={12}>
                            <p>{item.value}</p>
                          </Col>
                        </Row>
                      </li>
                    ))}
                  </ul>
                </Col>
                {fleetInfo?.comment && fleetInfo?.comment !== "" && (
                  <Col span={24}>
                    <span>Note: {fleetInfo?.comment}</span>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </React.Fragment>
      )}
    </Modal>
  );
};

export default RideSummaryModal;
